import { z } from 'zod'

/** Public plan catalog (PlanCatalogController — GET /api/v1/catalog/plans). */
export const catalogPlanSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  /** Base price in integer cents, in the plan's base currency. */
  priceCents: z.number().int(),
  currency: z.string(),
  billingCadence: z.enum(['MONTHLY', 'ANNUAL', 'WEEKLY']),
  trialDays: z.number().int().nullish(),
  /** Feature/limit map, e.g. { max_users: "25000", sso_enabled: "true" }. */
  features: z.record(z.string(), z.string()).default({}),
})

export type CatalogPlan = z.infer<typeof catalogPlanSchema>

/** GET /api/v1/catalog/currencies */
export const currencySchema = z.object({
  code: z.string(),
  name: z.string(),
  symbol: z.string(),
  decimalPlaces: z.number().int(),
  active: z.boolean(),
})

export type Currency = z.infer<typeof currencySchema>

/** Per-currency plan price rows (CurrencyController read endpoints). */
export const planPriceSchema = z.object({
  id: z.string(),
  planSlug: z.string(),
  currencyCode: z.string(),
  symbol: z.string().optional(),
  priceCents: z.number().int(),
})

export type PlanPrice = z.infer<typeof planPriceSchema>
